module.exports = __webpack_public_path__ + "om.svg?aa68baf3395942272c93d6664d84cb22";